import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Utility } from '../../shared/utility/utility';
import { CustomValidators } from '../../shared/utility/custom-validator';
import { AjaxService } from '../../services/ajax.service';
import { AppDetailsService } from '../../services/app-details.services';
import { EmitterService } from '../../services/emitter.service'
import { Router,ActivatedRoute } from '@angular/router';
import {CountryDataService} from '../../services/country.service';
import { environment } from '../../../environments/environment';

import * as _ from 'underscore';
import 'intl-tel-input';
import { UserDetailsService } from '../../services/user-details.service';
import { FormValidationComponent } from '../../form-validation/form-validation.component';
import { TranslateService } from '@ngx-translate/core';
import { language, statesAvailableCountrys } from '../../shared/utility/config';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";


@Component({
  selector: 'app-registration-step-two',
  templateUrl: './registration-step-two.component.html',
  styleUrls: ['./registration-step-two.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegistrationStepTwoComponent extends FormValidationComponent implements OnInit, AfterViewInit, OnDestroy {
  focusedElement;
  serverError;
  yearRange = [];
  availableCountry;
  availableCurrency;
  ipCountry;
  date;
  month;
  year;
  specificdate;
  error=[];
  steponeDetails;
  availableStates;
  isSelectedCountryStateDataAvailable = false;
  dobValidationDate='';
  dobValidationMonth='';
  dobValidationYear='';
  @Input() callingFrom;
  @Output() isStepThreeExempted = new EventEmitter<boolean>();
  langCode;
  prevUrl;
  @Input() fromNavBar:boolean=false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  excludedCountryList = _.union(environment.trustlyCountries,environment.fullPnpCountries);
  isRealUser = false;
  validDate;
  validMonth;
  validYear;
  isShowNames = false;
  dobValidationMes='';
  isSubmitted = false;
  
  constructor(
    private formBuilder: FormBuilder,
    private utils: Utility,
    private CustomValidators: CustomValidators,
    private ajaxService: AjaxService,
    private appDetails: AppDetailsService,
    private emitterService: EmitterService,
    private router: Router,
    private userDetailsService: UserDetailsService,
    private translate: TranslateService,
    private countryDataService:CountryDataService,
    private activatedRoute: ActivatedRoute
  ) {
    super(utils);
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode =>{
      this.langCode = langCode;
    });

    this.userDetailsService.userProfileUpdated$.pipe(takeUntil(this.destroy$)).subscribe(profile => {
      this.isRealUser = this.userDetailsService.isRealUserAccount();
    });

    // Temporary fix
    this.checkRegStepOneDataFilled();
    Promise.resolve(this.userDetailsService.checkUserProfile())
    .then(completeUserStatus => {
      this.isRealUser = this.userDetailsService.isRealUserAccount();
      if (completeUserStatus['userProfileCompleted'] || this.isRealUser || this.userDetailsService.checkIsPNPUser()) {
        // if (this.router.url.includes('completeprofile')) {
        //   this.router.navigate([this.langCode + '/otp']);
        // } else if(this.router.url.includes('/register/step2')) {
        //   this.router.navigate([this.langCode + '/register/step3']);
        // } else if(this.router.url.includes('/mob_register/step2')) {
        //   this.router.navigate([this.langCode + '/mob_register/step3']);
        // }
        this.router.navigate([this.langCode+ '/']);
      }
    });
    this.emitterService.broadcastAbortStepOne(false);
    this.checkYearShouldBeFourDigits();
  }

  restrictZero(event: KeyboardEvent, formFeild: string): void {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const invalidKeys = ['e', 'E', '+', '-', '.', ')', '(', '*', '/', '\\'];
  
    // Restrict 00 in month/date/year fields
    if ((formFeild === 'month' || formFeild === 'date') && value === '0' && key === '0' || invalidKeys.includes(key) || (formFeild === 'year' && value === '' && key === '0')) {
      event.preventDefault();
      return;
    }
  
    // After any keypress, clean year field if it starts with 0 (e.g., after deleting digits)
    if (formFeild === 'year') {
      setTimeout(() => {
        const cleaned = input.value.replace(/^0+/, '');
        if (cleaned !== input.value) {
          this.signUpStepTwo.controls[formFeild].setValue(cleaned);
          input.setSelectionRange(cleaned.length, cleaned.length); // code to move cursor to end
        }
      });
    }
  
    this.moveToNext(event);
  }
  
  
  //To auto focus on next field in Date of birth field of Registration step2 
  moveToNext(event: KeyboardEvent): void {
    // Shift+Tab key to move back
    if (event.shiftKey && event.key === 'Tab') {
      return;
    }
    setTimeout(() => {
      const currentInput = event.target as HTMLInputElement;
      const value = currentInput.value;
      const currentId = currentInput.id;
  
      // Expected length per field
      const expectedLengthMap: { [key: string]: number } = {
        dateFeild: 2,
        monthFeild: 2,
        yearFeild: 4
      };
  
      const nextFieldMap: { [key: string]: string } = {
        dateFeild: 'monthFeild',
        monthFeild: 'yearFeild'
      };
  
      const expectedLength = expectedLengthMap[currentId];
  
      // Only move focus if expected number of digits entered
      if (value.length >= expectedLength) {
        const nextId = nextFieldMap[currentId];
        if (nextId) {
          const nextInput = document.getElementById(nextId) as HTMLInputElement;
          if (nextInput) {
            nextInput.focus();
          }
        } else {
          currentInput.blur(); // No more fields to move to
        }
      }
    }, 0);
  }   

  updateDobValues(formFeild: string, id: string): void {
    let value = parseInt(this.signUpStepTwo.controls[formFeild].value, 10);
    if (isNaN(value)) return;
  
    if (formFeild === "year") {
      if (value > this.validYear) {
        this.signUpStepTwo.controls[formFeild].setValue(this.validYear);
      }
    } else if (formFeild === "month") {
      if (value > 12) {
        this.signUpStepTwo.controls[formFeild].setValue(12);
      }
    } else if (formFeild === "date") {
      if (value > 31) {
        this.signUpStepTwo.controls[formFeild].setValue(31);
      }
    }
  }
  
  checkRegStepOneDataFilled(){
    let userDetail = this.userDetailsService.getUserProfileDetails();
    if(userDetail && (!userDetail.lastName || !userDetail.firstName)){
      
      let firstNameValidation = new FormControl('', this.CustomValidators.validName(2, 30));
      this.signUpStepTwo.addControl('firstName', firstNameValidation);
      this.signUpStepTwo.controls['firstName'].setValue(userDetail.firstName ? userDetail.firstName : "")
      
      let lastNameValidation = new FormControl('', this.CustomValidators.validName(2, 30));
      this.signUpStepTwo.addControl('lastName', lastNameValidation);
      this.signUpStepTwo.controls['lastName'].setValue(userDetail.lastName ? userDetail.lastName : "")
      
      this.isShowNames = true;
    }else{
      this.isShowNames = false;
    }
  }
  ngOnInit() {
    this.isRealUser = this.userDetailsService.isRealUserAccount();
    this.initialstep();
    this.date = Array.from(new Array(31), (val, index) => index + 1);
    this.month = Array.from(new Array(12), (val, index) => index + 1);
    Promise.resolve(this.ajaxService.getProfileData()).then(profileDetails => {
      if (profileDetails) {
        this.steponeDetails= profileDetails;
      }
    });
    if (!this.availableCountry) {
      let countries = this.countryDataService.getCountries()
      .filter(country => (this.excludedCountryList).indexOf(country.iso) === -1);
      this.availableCountry = countries;
    }

  }
  ngAfterViewInit() {
    // Scroll to Registration page to Top on Step 2
    $(".reg_wrap").animate({
      scrollTop: 0
    });
    this.updateDatePreselect();
  }
  updateDatePreselect(){
    let currentDate = new Date();
    let eighteenYearsAgo:any = new Date(currentDate.setFullYear(currentDate.getFullYear()-18));
    this.validMonth = eighteenYearsAgo.getMonth() + 1; //months from 1-12
    this.validDate = eighteenYearsAgo.getDate();
    this.validYear = eighteenYearsAgo.getFullYear();
    //Future may requred Prefilling date
    // this.signUpStepTwo.controls["date"].setValue(this.updateDigits(this.validDate));
    // this.signUpStepTwo.controls["month"].setValue(this.updateDigits(this.validMonth));
    // this.signUpStepTwo.controls["year"].setValue(this.validYear);
  }
  updateDigits(number){
    if(number)
    return (number).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
    else 
      return ''
 }
 updateDateWithDigits(feildName){
  let date = this.signUpStepTwo.controls['date'].value;
  let month = this.signUpStepTwo.controls['month'].value;
  if(!(!date ||date == 0) && feildName == 'date' || !(!month || month == 0) && feildName =='month' ){
    if(feildName && feildName == 'date'){
      this.updateDigits(date)
      date = date == '0' || !date? '01' : this.updateDigits(date);
      this.signUpStepTwo.controls['date'].setValue(date);
     }else  if(feildName && feildName == 'month'){
      this.updateDigits(month)
      month = month == '0' || !month? '01' : this.updateDigits(month);
      this.signUpStepTwo.controls['month'].setValue(month);
     }
  }
  //  this.addDobValidationClass(feildName);
   this.dobValidationMessage();
 }
 checkDobAnyTwoValidation(){
  let results = {
    errorCount:0,
    message:''
  }
  if(this.shouldShowErrors('date',this.signUpStepTwo)){
    results.errorCount+=1;
    results.message = this.getErrorMessage('date',this.signUpStepTwo)
  }
  if(this.shouldShowErrors('month',this.signUpStepTwo)){
    results.errorCount+=1;
    results.message = CustomValidators.translationService.instant('errors.error24')
  }
  if(this.shouldShowErrors('year',this.signUpStepTwo)){
    results.errorCount+=1;
    results.message = CustomValidators.translationService.instant('errors.error24')
  } 
  return  results;
 }
 resetDobValidation(){
  this.dobValidationDate = '';
  this.dobValidationMonth = '';
  this.dobValidationYear = '';
  this.dobValidationMes = '';
 }
 addDobValidationClass(feildName){
  this.resetDobValidation();
  setTimeout(()=>{
    if(document.activeElement.id == 'yearFeild' || document.activeElement.id == 'monthFeild' || document.activeElement.id == 'dateFeild'){
      return null;
    }
    let date = this.signUpStepTwo.controls['date'].value
    let month = this.signUpStepTwo.controls['month'].value
    let year = this.signUpStepTwo.controls['year'].value
    if(date && month && year){
      this.dobValidationDate = this.getFormFiledClass('date', this.signUpStepTwo);
      this.dobValidationMonth = this.getFormFiledClass('month', this.signUpStepTwo);
      this.dobValidationYear = this.getFormFiledClass('year', this.signUpStepTwo)
    }
  },100);
 }
  signUpStepTwo = this.formBuilder.group({
    'address1': ['', this.CustomValidators.addressValidator(false)],
    'city': ['', this.CustomValidators.validName(2, 50)],
    'zip': ['', this.CustomValidators.validAlphaNumeric(2, 10)],
    // 'areaCode': [''],
    // 'areaCountryCode': [''],
    'country': ['', this.CustomValidators.required],
    'date': ['', [this.CustomValidators.required]],
    'month': ['', [this.CustomValidators.required]],
    'year': ['', [this.CustomValidators.required,Validators.minLength(4)]],
    'gender': ['M', [this.CustomValidators.required]]
  }, { validator: this.CustomValidators.dobValidator });
  initialstep() {
    let avCountryData = this.appDetails.getAvailableCountries();
    if (avCountryData) {
      this.setFirstStepReqData(avCountryData)
    } else {
      Promise.resolve(this.countryDataService.getCountriesDetails()).then(countryResponse => {
        this.appDetails.setAvailableCountries(countryResponse);
        let countryData = countryResponse;
        this.setFirstStepReqData(countryData);
      },
      SystemError => {
      });
    }
  }
  checkYearShouldBeFourDigits(){
    this.signUpStepTwo.get("year").valueChanges.subscribe(year => {
      if(year &&year < 1900){
       let  message = { 'message': CustomValidators.translationService.instant('errors.error14') }
        this.signUpStepTwo.controls['year'].setErrors(message);
      }
    })
  }
  onCountrySelect(){
    let selectedCountry = this.signUpStepTwo.controls['country'].value;
    let countryAvailableStates = statesAvailableCountrys;
    let selectedCountryInfo:any={}
    if(countryAvailableStates && countryAvailableStates.length){
      selectedCountryInfo = countryAvailableStates.filter((country) => country.countryIso === selectedCountry && country.isEnabled);
      if(selectedCountryInfo && !_.isEmpty(selectedCountryInfo)){
       let stateValidation = new FormControl('', this.CustomValidators.required);
       this.signUpStepTwo.addControl('state', stateValidation);
       this.availableStates = selectedCountryInfo[0].countryStates;
       this.signUpStepTwo.controls["state"].setValue(selectedCountryInfo[0].defaultState);
       this.isSelectedCountryStateDataAvailable = true;
      }else{
       this.updateDefault();
     }
    }else{
      this.updateDefault();
    }
  }
  updateDefault(){
      this.isSelectedCountryStateDataAvailable = false;
      this.signUpStepTwo.removeControl('state');
  }
  setFirstStepReqData(countryData) {
    this.yearRange = this.yearRange.length > 0 ? this.yearRange : _.sortBy(_.range(1900, new Date().getFullYear() - 17), function (num) { return -num; });
    if (countryData && countryData["countrylist"]) {
      this.ipCountry = countryData["country"];
      let countries = countryData["countrylist"]
      .filter(country => (this.excludedCountryList).indexOf(country.iso) === -1);
      /*Showing unrestricted countries in dropdown*/
      /**Hiding sweden details for non sweden countries from country dropdown*/
      this.availableCountry = this.ipCountry === "SE" ? countries : countries.filter((country)=>country.name!="Sweden");
      if (this.appDetails.blockedCountryResponse &&
        this.appDetails.blockedCountryResponse.hasOwnProperty("isIpBlocked") &&
      !JSON.parse(this.appDetails.blockedCountryResponse["isIpBlocked"]) ) {
        this.availableCountry.forEach(country => {
          if (country.iso === this.ipCountry && (!_.contains(environment.zimplerCountries, country.iso) || !_.contains(environment.semiPnpZimplerCountries, country.iso))) {
            this.signUpStepTwo.controls["country"].setValue(this.ipCountry);
            this.onCountrySelect()
          }
        });
      }
    }
  }

  updateUser(buttonId): void {
    this.isSubmitted = true;
    this.dobValidationMessage(true);
    if (this.signUpStepTwo.valid) {
      this.utils.disableNewButton(buttonId);
      /*Clean the form of unnecessary spaces*/
      this.signUpStepTwo = this.userDetailsService.cleanForm(this.signUpStepTwo);
      let data = this.utils.formControlToParams(this.signUpStepTwo, {});
      // data["nickname"] = data["username"];
      data['bDay'] =  data["date"];   //$('select[name=date]').val();
      data['bMonth'] = data["month"];//$('select[name=month]').val()
      data['bYear'] = data["year"]; //$('select[name=year]').val()
      // data['birthDate'] = data['bYear'] + '-' + data['bMonth'] + '-' + data['bDay'];
      if(!data["state"]){
        data['state'] = "-NA-";
      }
      data["language"] = language[this.langCode];
      delete data["date"];
      delete data["month"];
      delete data["year"];

      data = this.utils.modifyUserData(data);

      Promise.resolve(this.ajaxService.doProfileUpdate(data)).then(regData => {
          if (regData && regData["success"] && regData["success"]["status"] === "SUCCESS") {
            this.utils.disablescrollOnRegistrationPageOpend();
            if(this.utils.isMobile()){
              $('#navPanelToggle').show();
             }
            let isSHowDepositPage = localStorage.getItem('showRegisterPage');
            let isFromDeposit = localStorage.getItem('isFromDeposit');

            if (environment.stepThreeDepositIsEnabled && isSHowDepositPage == 'true' || isFromDeposit == 'true') {
              localStorage.removeItem('isFromDeposit');
              localStorage.removeItem('showRegisterPage');
              setTimeout(() => {
                this.emitterService.broadCastInitializePayment();
              }, 1000);
            }
     
            this.emitterService.broadcastCheckUserProfileFlag();
            // Please check below codereVerify() function is not required here
            this.activatedRoute.queryParams.subscribe(params => {
              this.prevUrl = params['prevUrl'];
            });
            if (!this.prevUrl) {
              this.prevUrl ="";
            }

            Promise.resolve(this.ajaxService.getProfileData()).then(profileDetails => {
              if (profileDetails) {
                this.userDetailsService.setUserProfileDetails(profileDetails);
                this.emitterService.broadcastRouteChange(false);
                if(!location.href.includes('gameplay')){
                  this.router.navigate([this.langCode]);
                }
                
                
                // this.router.navigate([this.langCode + '/'],{
                //   queryParams: {
                //     showDeposit: "true"
                //   }
                // }).then(()=>{
                //   history.replaceState(null,"", this.router.createUrlTree([this.langCode]).toString())
                // });
                
                this.emitterService.broadCastnotificationEvent("");
              }
            });
            this.emitterService.broadcastloginComplete("regTwo");
            this.utils.enableNewButton(buttonId, "SUCCESS", "SUCCESS", "Save");

          } else {
            for (let key in regData["errors"]) {
                if (regData["errors"][key]) {
                this.error.push(regData["errors"][key].message);
                }
            }
            this.serverError = this.translate.instant('errors.error');//"Somthing went wrong";

            /* Below if condition (mob_register) is for New registration page for Mobile devices */
            if (this.router.url.includes('mob_register/step2')){
            this.emitterService.broadcastserverError(this.serverError, '/mob_register/step2');
            } else {
              this.emitterService.broadcastserverError(this.serverError, '/register');
            }

            this.utils.enableNewButton(buttonId, "FAILED", "Save", "Save");
           }
      },
      SystemError => {
      });
    }
    else {
      // this.utils.enableNewButton(buttonId, "FAILED", "Please Try Again", "Save");
      this.utils.validateAllFormFields(this.signUpStepTwo);
    }
  }
  codereVerify() {

    let logincredentials = {
      'email': this.steponeDetails.email,
      'channel': "sms"
    }
    Promise.resolve(this.ajaxService.resendEmailVerification(logincredentials))
      .then(regData => {
      },
        SystemError => {
          this.emitterService.broadcastserverError(this.serverError,"/register")
        })
  }
  getValidFormContols(formGroup: FormGroup, validControls) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl && control.valid && field !== this.focusedElement) {
        validControls.push(field)
      } else if (control instanceof FormGroup) {
        this.getValidFormContols(control, validControls);
      }
    });
    return validControls;
  }

  getButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }
  
  dobValidationMessage(isSubmitted = false){
    if(this.isSubmitted){
      isSubmitted = true;
    }
    let data = this.checkDobAnyTwoValidation();
    let date  = this.signUpStepTwo.controls['date'].value;
    let month  = this.signUpStepTwo.controls['month'].value;
    let year  = this.signUpStepTwo.controls['year'].value;
    let checkAllFeildsAreValid = date && month && year ? true : false;
    if(!date && !month && !year && parseInt(date) != 0 && parseInt(year) != 0 && parseInt(year) != 0 && !isSubmitted){
      this.dobValidationMes = '';
      return;
    }else if(!date || !month || !year){
      this.dobValidationMes = CustomValidators.translationService.instant('errors.error24');
    }else if(data.errorCount == 1){
      if(checkAllFeildsAreValid){
        this.dobValidationMes = this.getMessageForDob(year);
      }else {
        this.dobValidationMes = data.message;
      }
    }else if(data.errorCount >= 2 && checkAllFeildsAreValid){
      this.dobValidationMes = CustomValidators.translationService.instant('registrationStepTwo.commonDOBErroMsg')
    }else if(checkAllFeildsAreValid){
      this.dobValidationMes = this.getMessageForDob(year);
    }
    let results = this.dobValidationMes ? this.dobValidationMes : ''
    this.dobValidationDate = results ? 'has-error' : 'has-success';
    this.dobValidationMonth = results ? 'has-error' : 'has-success';
    this.dobValidationYear = results ? 'has-error' : 'has-success';
    return results
  
  }
  getMessageForDob(year){
    let mes = ''
    if(this.shouldShowErrors('date',this.signUpStepTwo)){
      mes = this.getErrorMessage('date',this.signUpStepTwo);
    }else if(this.shouldShowErrors('month',this.signUpStepTwo)){
      mes = CustomValidators.translationService.instant('errors.error24')
    }else if(this.shouldShowErrors('year',this.signUpStepTwo)){
      if(year < 1900 ){
        mes = CustomValidators.translationService.instant('errors.yearRestriction')
      }
    }
    return mes;
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
